import React from 'react';
import auth from 'account/login';
import {connect} from 'react-redux';
import {apiUrl, picUrl} from 'config';
import {bindActionCreators} from 'redux';
import {fetchDataIfNeeded} from 'redux/ajax/action';
import UserConfig from '../../pages/user/components/ajax-config';
import {Link} from 'react-router';

var View = React.createClass({
    render: function () {
        let {item} = this.props;
        return (
            <div className="topbar">
                <div className="container">
                    <Link to="/"><i className="iconfont icon-home"/>返回首页</Link>
                    <div className="fr">
                        {item.name}，欢迎你！
                        <a href="javascript:;" className="special" onClick={this.logout}>
                            退出<i className="iconfont icon-logout"/></a>
                    </div>
                </div>
            </div>
        )
    },
    logout: function () {
        auth.logout();
    },
    componentDidMount(){
        this.props.fetchDataIfNeeded(UserConfig);
    }
});

function mapStateToProps(state) {
    var list = state.ajaxData[UserConfig.viewName], userInfo = {fetching: true};
    if (list && !list.fetching && list.items.length) {
        Object.assign(userInfo, list.items[0], {fetching: list.fetching});
    }
    return {
        item: userInfo
    }
}

function mapDispatchToProps(dispatch) {
    return {
        fetchDataIfNeeded: bindActionCreators(fetchDataIfNeeded, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(View);


// WEBPACK FOOTER //
// ./components/common/topbar.jsx